import { FC, useState, useRef, useEffect } from "react";

interface DropdownProps {
  trigger: React.ReactNode;
  items: {
    label: string;
    onClick: () => void;
  }[];
  showAll?: boolean;
  selectAll?: () => void;
  disabled?: boolean;
}

const Dropdown: FC<DropdownProps> = ({ trigger, items, showAll, selectAll, disabled = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      {/* Trigger button */}
      <div 
        onClick={() => !disabled && setIsOpen(!isOpen)} 
        className={`cursor-${disabled ? 'not-allowed' : 'pointer'} h-full flex items-center ${disabled ? 'opacity-50' : ''}`}
      >
        {trigger}
      </div>

      {/* Updated dropdown menu styling */}
      <div 
        className={`absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-muted-lightGrey border border-muted-grey hover:shadow-[10px_10px_0_-2px_theme(colors.muted.grey)] transition-all duration-300 ease-in-out transform ${
          isOpen && !disabled
            ? 'opacity-100 scale-100 translate-y-0' 
            : 'opacity-0 scale-95 -translate-y-2 pointer-events-none hidden'
        }`}
      >
        {showAll && (
          <button
            onClick={() => {
              selectAll?.();
              setIsOpen(false);
            }}
            className="block w-full text-center px-4 py-2 text-sm text-muted-black hover:bg-white transition-all duration-300"
          >
            All
          </button>
        )}
        {items.map((item, index) => (
          <button
            key={index}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              item.onClick();
              setIsOpen(false);
            }}
            className="block w-full text-center px-4 py-2 text-sm text-muted-black hover:bg-white transition-all duration-300"
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Dropdown; 